import type { ContentfulArticle, ContentfulExternalLink, ContentfulMediaLink } from "../common/types/cmsTypes";
import { isExternalLink } from "../common/utils";
import { DownloadLink, ExternalLink, InternalLink } from "../components/Links";
import contentStore from "../stores/cms/contentStore";

export type FooterLink = ContentfulArticle | ContentfulMediaLink | ContentfulExternalLink;

type ContentfulFooterLinkProps = {
   content: FooterLink;
};

const ContentfulFooterLink = ({ content }: ContentfulFooterLinkProps) => {
   if (content?.sys?.contentType?.sys?.id === "v2_article") {
      const article = content as ContentfulArticle;
      const id = article.sys.id;
      const linkText = article.fields.title;
      const fullUrl = `/${contentStore.urlData.data.find((data) => data.id === id)?.fullUrl}`;

      return (
         <InternalLink
            href={fullUrl}
            className="text-headerFooterText no-underline hover:underline"
            trackingLocationName="Footer"
         >
            {linkText}
         </InternalLink>
      );
   }

   if (content?.sys?.contentType?.sys?.id === "externalLink") {
      const externalLink = content as ContentfulExternalLink;
      const url = externalLink.fields.url;
      const linkText = externalLink.fields.linkText;
      const linkClassName = "text-headerFooterText no-underline hover:underline";

      if (isExternalLink(url)) {
         return (
            <ExternalLink href={url} className={linkClassName}>
               {linkText}
            </ExternalLink>
         );
      }

      return (
         <InternalLink trackingLocationName="Footer" href={url} className={linkClassName}>
            {linkText}
         </InternalLink>
      );
   }

   if (content?.sys?.contentType?.sys?.id === "linkToMedia") {
      const externalLink = content as ContentfulMediaLink;
      const url = externalLink.fields.media?.fields.file?.url;
      const linkText = externalLink.fields.linkText;
      return (
         <DownloadLink href={url} className="text-headerFooterText no-underline hover:underline">
            {linkText}
         </DownloadLink>
      );
   }
};

export default ContentfulFooterLink;
